import request from '@/utils/request'

export function newPageView(query) {
  return request({
    url: '/pv/newpv',
    method: 'get',
    params: query
  })
}

export function newToolView(query) {
  return request({
    url: '/pv/newtv',
    method: 'get',
    params: query
  })
}

export function getViews(query) {
  return request({
    url: '/pv/list',
    method: 'get',
    params: query
  })
}

export function getUserIP() {
  return request({
    url: 'https://api.ipify.org?format=json',
    method: 'get',
    params: {}
  })
}
